var _g, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _rect, _rect2, _g2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 275,
    viewBox: "0 0 275 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2032_1569)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 133.5,
    r: 107.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 195.88V101.728L168.5 54.1195V148.272L33.5 195.88Z",
    fill: "white",
    stroke: "#E4F1F3",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 188.866V93.3875L157.5 45.1344V140.613L23.5 188.866Z",
    fill: "white",
    stroke: "#8FA1AC",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 182.88V88.7282L145.5 41.1195V135.272L10.5 182.88Z",
    fill: "white",
    stroke: "#404040",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24 98L99 73V80L24 106V98Z",
    fill: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24 115L99 89V96L24 123V115Z",
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24 131L99 105V112L24 139V131Z",
    fill: "#C4C4C4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 55,
    r: 3,
    fill: "#BFBFBF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 61,
    r: 1.5,
    stroke: "#BFBFBF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 202,
    r: 2,
    fill: "#EF8B22"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 238,
    r: 4.5,
    stroke: "#EF8B22"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 192.922,
    y: 47,
    width: 1.15789,
    height: 11,
    rx: 0.578947,
    fill: "#BFBFBF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 53.0791,
    width: 1.15789,
    height: 11,
    rx: 0.578947,
    transform: "rotate(-90 188 53.0791)",
    fill: "#BFBFBF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2032_1569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6172 192.664L76.4382 143.483L77.0007 141.02L135.363 154.6L178.817 162.128L198.154 188.772L192.107 187.458L217.351 192.946V222.567L179.31 225.03L144.011 223.834L105.689 225.03L95.3531 223.834L92.6108 222.919H82.2041H78.5476L63.6408 221.371V211.591L62.7267 210.395V209.48L63.6408 208.847V202.726H62.0938V192.664H60.6172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5781 144.609L99.4307 185.136L143.143 190.144V188.807L100.064 183.166L77.2813 142.99L76.5781 144.609Z",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.133 183.166L99.6406 185.136",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.858 189.217L179.169 162.128L77.1413 141.935L60.6875 192.594H62.6563L77.8445 146.789",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M104.212 195.057L143.142 198.217L143.493 222.788L104.212 223.834L93.2423 222.638H90.7812V196.534H93.2423L104.212 195.057Z",
    fill: "#B1D6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.633 192.946L178.819 185.065L143.496 188.74V191.202V222.864",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6562 192.594V202.655H67.0166V209.199H62.6562V210.113L63.3594 210.958V215.777V221.23",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3594 220.597L74.9614 221.442L77.7741 221.09L90.7824 222.497L92.8216 222.215L104.705 223.13L145.136 222.286L178.817 224.256L217.35 221.019V192.312",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8516 202.937V209.199",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2422 221.441L75.1016 171.626L86.9146 167.264V193.157L77.1407 193.86L77.422 221.09",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7266 169.516V193.579",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4141 168.953V193.579",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2422 193.086V170.923L86.9142 170.219",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7267 172.049L78.5469 172.964L78.8281 193.579",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6406 222.005V196.323L92.8204 196.534L103.579 195.057L143.142 198.217V222.437",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.789 186.05V195.056",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8125 196.534V222.567",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M149.109 197.515H144.195V218.997L149.109 219.277V197.515Z",
    fill: "#B1D6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.055 195.76V222.919",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.816 196.813V223.128",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M164.473 219.964V196.534L170.942 196.464V220.246L164.473 219.964Z",
    fill: "#B1D6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.488 196.956V222.849",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.367 197.515V223.196",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.816 185.065V224.256",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.195 197.515H149.109V219.277L144.195 219.207",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.785 196.605V219.823L171.082 220.175V196.394L162.785 196.605Z",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.613 196.534V219.894",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M191.547 219.05V197.801L211.657 199.912V217.853L191.547 219.05Z",
    fill: "#B1D6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.617 196.112V219.26L213.626 217.994V198.645L191.617 196.112Z",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.754 197.589L211.653 199.7L213.622 198.574",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.656 199.912V217.853",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.902 198.152V218.838",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.883 198.786V218.627",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.016 199.349V218.205",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7891 144.679L99.6416 185.065",
    stroke: "#8FA1AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M78.6172 193.509V172.893L78.8985 172.612L80.7267 171.979V193.509H78.6172Z",
    fill: "#B1D6DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M84.3828 193.227V171.064L86.8439 170.431V193.227H84.3828Z",
    fill: "#B1D6DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M136.489 200.193L109.418 213.561V215.672L136.489 200.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M211.305 205.399L195.484 213.28V214.546L211.305 205.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M137.966 204.766L110.895 218.135V220.245L137.966 204.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M211.934 207.792L196.113 215.672V216.938L211.934 207.792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.605 190.272L178.818 186.965L216.929 194.564",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M87.4102 144.186L104.286 174.089L175.305 181.477L159.392 158.796L87.4102 144.186Z",
    fill: "#8FA1AC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.5,
    y: 195,
    width: 2,
    height: 19,
    rx: 1,
    fill: "#4094CB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 205.5,
    width: 2,
    height: 19,
    rx: 1,
    transform: "rotate(-90 225 205.5)",
    fill: "#4094CB"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M231.5 222.015H219.805L181.334 225.245L147.707 223.279L107.341 224.122L95.4768 223.209L93.4409 223.49L80.4534 222.086L77.6453 222.437L66.0619 221.594H55",
    stroke: "#8FA1AC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5619 129.008C91.1276 128.937 90.7657 129.361 90.9829 129.714L101.623 149.482L110.959 166.78C111.104 167.133 111.466 167.345 111.828 167.345L181.601 176.029C182.035 176.099 182.325 175.605 182.107 175.252L160.706 142.267C160.706 142.267 160.489 142.055 160.344 142.055L91.5619 129.008Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M110.148 132.578L130.156 169.434",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M128.402 136.088L148.41 172.242",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M145.602 139.247L165.96 175.05",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M100.672 146.969L170.523 157.851",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M205.988 142.755C209.71 147.043 212.127 153.161 212.164 158.724C212.191 162.907 210.837 166.198 208.446 167.755C207.821 168.164 207.138 168.442 206.413 168.597",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M205.988 142.755C209.71 147.043 212.127 153.161 212.164 158.724C212.191 162.907 210.837 166.198 208.446 167.755C207.821 168.164 207.138 168.442 206.413 168.597",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M196.663 137.502L204.125 135.923C203.985 135.918 203.844 135.923 203.704 135.927L196.242 137.507C196.382 137.502 196.523 137.502 196.663 137.502Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M196.241 137.507L203.703 135.928C203.309 135.941 202.929 135.991 202.562 136.069L195.1 137.648C195.472 137.571 195.852 137.525 196.241 137.507Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M202.323 167.759L209.785 166.179C209.328 166.011 208.861 165.806 208.391 165.556C207.906 165.296 207.426 165.005 206.955 164.677L199.493 166.257C199.964 166.585 200.444 166.876 200.929 167.135C201.4 167.386 201.866 167.59 202.323 167.759Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M199.495 166.262L206.957 164.682C205.703 163.817 204.512 162.72 203.416 161.464L195.954 163.043C197.05 164.3 198.241 165.392 199.495 166.262Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M195.952 163.039L203.414 161.459C199.756 157.249 197.206 151.213 197.148 145.778C197.111 142.564 197.981 139.874 199.593 138.217C200.448 137.339 201.49 136.765 202.658 136.515L195.196 138.094C194.028 138.34 192.987 138.914 192.131 139.797C190.519 141.453 189.65 144.144 189.686 147.357C189.749 152.792 192.298 158.833 195.952 163.039Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M196.878 137.962L204.34 136.383C204.136 136.374 203.937 136.374 203.738 136.383L196.276 137.962C196.475 137.953 196.674 137.953 196.878 137.962Z",
    fill: "#949494"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M196.28 137.962L203.742 136.383C203.371 136.396 203.009 136.442 202.66 136.515L195.198 138.094C195.547 138.022 195.909 137.976 196.28 137.962Z",
    fill: "#999999"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M197.101 137.976L204.559 136.401L204.341 136.388L196.879 137.963L197.101 137.976Z",
    fill: "#969696"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M197.101 137.976L204.559 136.401L204.319 111.607L196.861 113.182L197.101 137.976Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M196.858 113.181L204.32 111.602C203.451 110.905 202.609 110.086 201.812 109.171L194.35 110.75C195.147 111.67 195.989 112.489 196.858 113.181Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M194.351 110.75L201.812 109.176C197.588 104.314 194.545 96.6805 194.468 90.2622C194.396 84.0762 197.217 79.5106 201.677 78.541L194.215 80.1205C189.75 81.0855 186.934 85.6511 187.002 91.8372C187.084 98.2554 190.126 105.889 194.351 110.75Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M194.461 94.0221L201.918 92.4472L201.678 78.541L194.221 80.1205L194.461 94.0221Z",
    fill: "#C9C6C6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M194.386 79.6249L201.844 78.0454C201.771 78.0591 201.699 78.0727 201.626 78.0909L194.165 79.6659C194.237 79.6522 194.314 79.6386 194.386 79.6249Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M194.636 79.5795L202.098 78L201.844 78.0455L194.387 79.625L194.636 79.5795Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203.918 141.267L211.375 139.688L211.09 113.455L203.628 115.03L203.918 141.267Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M203.858 115.053L211.32 113.478L211.089 113.455L203.628 115.03L203.858 115.053Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M206.359 114.93L213.816 113.35C213.391 113.441 212.956 113.496 212.512 113.509L205.051 115.089C205.499 115.071 205.933 115.016 206.359 114.93Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M205.054 115.089L212.516 113.51C212.23 113.523 211.936 113.519 211.642 113.5C211.538 113.496 211.429 113.487 211.32 113.473L203.858 115.053C203.967 115.062 204.071 115.071 204.18 115.08C204.474 115.098 204.764 115.103 205.054 115.089Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M206.183 100.737L213.645 99.1573L201.918 92.4478L194.46 94.0227L206.183 100.737Z",
    fill: "#929292"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M196.265 93.9676L205.824 99.4477L211.817 98.1792L202.253 92.7029L196.265 93.9676Z",
    fill: "white",
    stroke: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M202.236 86.2842L202.336 93.7494L194.458 94.0225L194.53 88.3599L202.236 86.2842Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M202.098 84.7957L194.459 86.844V85.3829L202.184 83.2207L202.098 84.7957Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M202.1 81.418L202.168 81.987L194.715 83.9215V83.2205L202.1 81.418Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M221.105 104.52C221.105 104.52 220.331 112.358 214.391 113.651L206.467 115.362C206.467 115.362 212.507 113.514 213.114 106.745L221.105 104.52Z",
    fill: "#BFBFBF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M221.237 103.117L213.345 105.17L213.445 102.976L221.332 100.918L221.237 103.117Z",
    fill: "#BFBFBF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M221.21 99.1116L213.866 101.064L213.734 100.423L221.187 98.5244L221.219 99.2846",
    fill: "#BFBFBF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M220.672 97.1181L213.264 98.9434L213.206 98.6566L220.658 96.7539L220.672 97.1181Z",
    fill: "#BFBFBF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M211.522 113.946L211.648 121.794C211.648 121.794 207.578 125.203 203.734 124.197L203.634 115.03C203.63 115.03 209.262 115.685 211.522 113.946Z",
    fill: "#BFBFBF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M219.574 158.601C219.574 158.601 219.158 164.964 214.865 166.717L206.874 168.278C206.874 168.278 210.641 169.011 211.823 160.749L219.574 158.601Z",
    fill: "#BFBFBF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M219.617 156.598L211.947 158.601V156.598L219.454 154.613L219.617 156.598Z",
    fill: "#BFBFBF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M219.059 152.397L211.692 154.404L211.375 153.507L218.837 151.491L219.059 152.397Z",
    fill: "#BFBFBF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M194.22 80.1206C189.756 81.0856 186.94 85.6512 187.008 91.8373C187.098 99.4663 191.381 108.811 196.77 113.113L197.096 137.971L196.878 137.957C195.022 137.876 193.383 138.508 192.133 139.792C190.521 141.449 189.652 144.139 189.688 147.353C189.774 155.023 194.818 163.894 200.931 167.131C202.207 167.809 203.457 168.182 204.63 168.255C205.947 168.337 207.165 168.037 208.216 167.354C210.48 165.879 211.761 162.729 211.734 158.705C211.693 152.414 208.551 145.404 203.914 141.258L203.625 115.02L203.856 115.043C203.964 115.052 204.068 115.061 204.177 115.07C206.432 115.211 208.465 114.469 210.059 112.917C212.264 110.769 213.468 107.236 213.441 102.967C213.409 97.3178 211.2 91.1818 207.537 86.5661C207.039 85.9425 206.518 85.3508 205.975 84.8L206.183 100.736L194.46 94.0268L194.22 80.1206Z",
    fill: "#E9E8E7",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M198.281 148.707C197.743 148.956 197.276 149.605 197.137 150.74C197 151.856 197.215 153.28 197.873 154.718C198.53 156.155 199.466 157.247 200.397 157.869C201.344 158.502 202.139 158.568 202.676 158.32C203.214 158.071 203.681 157.422 203.82 156.287C203.957 155.171 203.741 153.747 203.084 152.309C202.427 150.872 201.491 149.78 200.56 149.158C199.612 148.525 198.818 148.459 198.281 148.707Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M206.562 168.479C206.562 168.479 212.665 165.242 210.818 154.004C210.818 154.004 209.197 145.155 204.266 141.586L203.759 141.176L211.724 139.41L213.449 141.176C217.171 145.464 219.588 151.582 219.625 157.144C219.652 161.328 218.298 164.619 215.907 166.176C215.282 166.585 214.599 166.863 213.874 167.018L206.412 168.597",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M194.879 93.7497L202.336 92.1747L202.096 78L194.634 79.5795L194.879 93.7497Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M204.265 140.989L211.723 139.414L211.519 113.946L204.057 115.526L204.265 140.989Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M206.471 115.362L213.933 113.782C215.405 113.473 216.709 112.767 217.818 111.688C220.109 109.458 221.359 105.807 221.332 101.41C221.295 95.6381 219.05 89.3928 215.323 84.6998C215.106 84.4312 214.001 82.9746 212.797 81.9868L205.815 83.3888C205.652 83.4207 205.584 83.621 205.693 83.7484C206.29 84.4358 207.689 86.0517 207.866 86.2747C211.592 90.9678 213.843 97.213 213.874 102.985C213.901 107.382 212.652 111.033 210.361 113.263C209.247 114.342 207.943 115.048 206.471 115.362Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M114 69.5L132.5 62V75L114 82.5V69.5Z",
    fill: "#C4C4C4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114 85.5L132.5 78V91L114 98.5V85.5Z",
    fill: "#C4C4C4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114 101.5L132.5 94V107L114 114.5V101.5Z",
    fill: "#C4C4C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2032_1569",
    x: 0,
    y: 0,
    width: 275,
    height: 275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898021 0 0 0 0 0.914208 0 0 0 0 0.925 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2032_1569"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2032_1569",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2032_1569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 218.33,
    height: 94.0713,
    fill: "white",
    transform: "translate(41 132.929)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCases);
export default __webpack_public_path__ + "static/media/empty-cases.6f8e2ff6e5f059ec03cc6b969eac2cdc.svg";
export { ForwardRef as ReactComponent };